import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function Tcmodel(props) {


  return (
    <>

      <Modal {...props} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Blaccdot User Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Box
              sx={{ maxHeight: "400px", overflowY: "auto",
                borderRadius: "8px",}}>
              <h4>Website Terms of Use</h4>
            <p>This Site operates as an online marketplace to enable Users to post Jobs, and Transport Providers to quote for these Jobs, with a view to entering into a Transaction.</p>
            <h5>INFORMATION WHICH WE ARE REQUIRED TO GIVE YOU</h5>
            <p>www.blaccdot.com is a site operated by BlaccDot Worldwide Limited ("we" or "us"), a company which is registered in India under company registration number 33AAHFE9568J1ZY. Our registered office is at address as 10/1028 Seethakathi, 3rd Cross Street Mogappair East, Chennai 600037 . Our email address is support@blaccdot.com</p>
            <p>Part A (the "General Conditions") and Part B (the "Supplemental Conditions") of these terms and conditions (together with the documents referred to within) set out the terms and conditions on which we will provide our services to you.</p>
            <p>You may access most areas of the Site without the need for Registration in which case only the General Conditions will apply to you. Certain areas of the Site are only open to you if you are a Member and if you decide to register as a Member you will be asked to confirm expressly that you have read and accept the Supplemental Conditions as well as the General Conditions.</p>
            <p>The Conditions (as defined below) apply to the access to and use of the Site, and to any correspondence by e-mail between you and us. Please read these terms carefully before using the site. Using the Site indicates that you accept the General Conditions regardless of whether or not you choose to become a Member. If you do not accept the General Conditions, do not use the Site</p>
            <p>We may revise the Conditions at any time by updating this posting. You should check the Site from time to time to review the current version of the Conditions because they are binding on you. Certain provisions in the Conditions may be superseded by expressly designated legal notices located on particular pages of the Site</p>
            <p>Any rights not expressly granted in these terms are reserved.</p>

            <h5>PART A</h5>
            <h5>GENERAL CONDITIONS</h5>

            <h5>DEFINITIONS</h5>
            <ol>
              <li>"Transport Provider" means a Member who has submitted a quotation in respect of a Job</li>
              <li>"Conditions" means all conditions applicable to a person accessing the Site in connection with his use of the Site (i.e. for a mere visitor, the General Conditions alone, and for a Member, the General Conditions and the Supplementary Conditions);
              </li>
              <li>"User" means a Member who has posted a Job on the Site</li>
              <li>"Job" means the transportation request posted by the User on the Site</li>
              <li>"Member" means a person who has Registered (and "Membership" means the status of being a Member)</li>
              <li>"Registration" or "Register" means setting up a membership account having agreed to the Conditions</li>
              <li>"Site" means www.blaccdot.com; and</li>
              <li>"Transaction" means the agreement entered into between a Transport Provider and a User for the performance of a Job.</li>
              <li>"Book Now" means Jobs which are booked after seeing instant rates rather than undergoing the auction process.</li>
            </ol>

            <h5>ACCESS</h5>
            <ol>
            <li>Whilst we endeavour to ensure that the Site is available 24 hours a day, we shall not be liable if, for any reason, the Site is unavailable at any time or for any period.</li>
              <li>Access to the Site may be suspended temporarily and without notice in the case of a system failure, maintenance or repair or for any reasons beyond our control.
              </li>
              <li>Access to the Site may be suspended temporarily and without notice in the case of a system failure, maintenance or repair or for any reasons beyond our control.
              </li>
            </ol>

            <h5>CONTENT</h5>
            <ol>
            <li>Whilst we endeavour to ensure that the information on the Site is correct, we do not warrant the accuracy or completeness of the material on the Site. We may make changes to the material on the Site at any time and without notice. The material on the Site may be out of date, and we make no commitment to update such material.</li>
              <li>The contents of the Site are provided "as is", and we provide no warranties in respect of such contents.
              </li>
              <li>You are prohibited from posting or transmitting to or from the Site any material:</li>
              <ol>
                <li>that is threatening, defamatory, obscene, indecent, offensive, pornographic, abusive, liable to incite racial hatred, discriminatory, menacing, scandalous, inflammatory, blasphemous, in breach of confidence, in breach of privacy or which may cause annoyance or inconvenience;
                </li>
                <li>for which you have not obtained all necessary licences and/or approvals;</li>
                <li>which constitutes or encourages conduct that would be considered a criminal offence, gives rise to civil liability, is otherwise unlawful or infringes the rights of any third party, in any country in the world; or</li>
                <li>which is technically harmful (including, without limitation, computer viruses, logic bombs, Trojan horses, worms, harmful components, corrupted data or other malicious software or harmful data).
                </li>
              </ol>
              <li>You may not misuse the Site (including, without limitation, by hacking).</li>
              <li>We will co-operate fully with any law enforcement authorities or court order requesting or directing us to disclose the identity of, or locate, anyone posting any material in breach of this clause 3. </li>
            </ol>

            <h5>LICENCE</h5>
            <ol>
              <li>You are permitted to view, print and download extracts from the Site for your own use on the basis that:</li>
              <ol>
              <li>No documents or related graphics on the Site are modified in any way:</li>
              <li>No graphics on the Site are used separately from the corresponding text; and</li>
              <li>our copyright notices and this permission notice appear in all copies.</li>
              </ol>
              <li>Unless otherwise stated, the copyright and other intellectual property rights in all material on the Site (including, without limitation, photographs and graphical images) are owned by us or our licensors. Saved as agreed otherwise, any use of extracts from the Site other than in accordance with clause 4.1 is prohibited, and if you breach clause 4.1, your permission to use the Site automatically terminates and you must immediately destroy any downloaded or printed extracts from the Site.
              </li>
              <li>Subject to clause 4.1, no part of the Site may be reproduced or stored on any other website or included in any public or private electronic retrieval system or service without our prior written permission.
              </li>
            </ol>

            <h5>DISCLAIMER</h5>
            <p>To the extent permitted by law, we hereby exclude:</p>
            <ol>
              <li>all conditions, warranties, representations, and other terms which might otherwise be implied by statute, common law, or the law of equity; and
              </li>
              <li>any liability for any direct, indirect, or consequential loss or damage incurred by any user in connection with the Site or in connection with the use, inability to use, or results of the use of the Site, any websites linked to the Site, or the material on such websites, including, without limitation, any liability for:
              </li>

              <p>1. loss of income or revenue </p>
              <p>2. loss of business</p>
              <p>3. loss of profits or contracts</p>
              <p>4. loss of anticipated savings</p>
              <p>5. loss of data</p>
              <p>6. loss of goodwill</p>
              <p>7. wasted management or office time; and</p>
              <p>8. any other loss or damage of any kind, however arising, and whether caused by tort (including negligence), breach of contract, or otherwise, even if foreseeable.</p>

              <li>Nothing in these Conditions shall exclude or limit our liability for</li>
              <ol>
                <li>Death or personal injury caused by our negligence</li>
                <li>Fraud or fraudulent misrepresentation; or</li>
                <li>Any other liability which cannot be excluded or limited under applicable law</li>
              </ol>
            </ol>

            <h5>6. INDEMNITY</h5>

            <p>You agree to indemnify and hold us harmless from any and all claims, losses, damages, liabilities, costs, and expenses (including reasonable legal fees) arising out of:</p>

            <ol>
              <li>your use of the Site</li>
              <li>Any content you submit, post, or transmit through the Site</li>
              <li>Any violation of these Conditions by you</li>
              <li>Any violation of any third-party rights by you; and</li>
              <li>any claim made by a third party against us arising out of or in connection with any of the above.
              </li>
              <li>LINKS TO AND FROM OTHER WEBSITES</li>
              <ol>
                <li>Links to third-party websites on the Site are provided for your convenience only. If you use these links, you leave the Site. We have not reviewed these third-party websites and do not control and are not responsible for them or their content. We do not endorse or make any representations about them, or any material found on them, or any results that may be obtained from using them.
                </li>
                <li>If you would like to link to the Site, you may do so provided that you comply with the following conditions:
                </li>
                <ol>
                  <li>the link must be to the homepage of the Site</li>
                  <li>the link must not suggest any affiliation or endorsement by us without our express written consent</li>
                  <li>the link must not be in any way misleading</li>
                  <li>the link must not be defamatory, offensive, or otherwise harmful.</li>
              </ol>
              <li>DOMAIN NAME PROTECTION
                We have the right to block any domain name that is found to be in violation of these Terms of Use or which may be associated with fraudulent activity or other illicit use. We also reserve the right to take appropriate action regarding such domain names, including legal action, if deemed necessary.</li>
                <li>GENERAL CONDITIONS</li>
                <ol>
                  <li>Entire Agreement : These Conditions constitute the entire agreement between you and us regarding the use of the Site and supersede any prior agreements or understandings you may have had with us</li>
                  <li>Governing Law and Jurisdiction: These Conditions shall be governed by and construed in accordance with the laws of India, and any disputes arising in connection with these Conditions shall be subject to the exclusive jurisdiction of the courts of Tamil Nadu, India
                  </li>
                  <li>Waiver: Our failure to enforce any right or provision of these Conditions shall not be deemed a waiver of such right or provision.
                  </li>
                </ol>
            </ol>
            </ol>


            <h4>PART B</h4>
            <h5>SUPPLEMENTAL CONDITIONS</h5>
            <ol>
              <li><h6>ACCOUNT AND REGISTRATION</h6></li>
              <li>By accessing and using the Site, you agree to provide accurate and complete information about yourself when required. You are responsible for maintaining the confidentiality of your account and password and for all activities that occur under your account.
              </li>
              <li>You must notify us immediately if you suspect any unauthorized use of your account or any other security breach.</li>
            </ol>
            <ol>
              <li><h6>USE OF THE SITE</h6></li>
              <li>You agree to use the Site solely for lawful purposes and in accordance with these Conditions.
              </li>
              <li>You are prohibited from</li>
              <ol>
                <li>using the Site to transmit any harmful or offensive content</li>
                <li>engaging in any activity that disrupts or interferes with the Site or its services</li>
                <li>attempting to access any non-public areas of the Site</li>
                <li>using any automated means to extract data from the Site.</li>
              </ol>
              <li><h5 className="mt-4">PRIVACY POLICY</h5>
              We are committed to protecting your privacy. Please review our Privacy Policy to understand how we collect, use, and protect your personal information.
              </li>
              <li><h5 className="mt-4">CHANGES TO THE TERMS AND CONDITIONS</h5>
              We may modify these Terms and Conditions from time to time. Any changes will be posted on this page, and the effective date will be updated accordingly. Your continued use of the Site following any changes to the Terms and Conditions will constitute acceptance of those changes.
              </li>
              <li><h5 className="mt-4">DISPUTE RESOLUTION</h5>
              Any disputes arising from or related to the use of the Site or these Terms and Conditions will be subject to the exclusive jurisdiction of the courts of Tamil Nadu, India.
              </li>
              <li><h5 className="mt-4">FORCE MAJEURE</h5>
              We shall not be held liable for any failure or delay in performance under these Terms and Conditions due to causes beyond our reasonable control, including but not limited to acts of God, war, terrorism, government action, or natural disasters.
              </li>
              <li><h5 className="mt-4">ASSIGNMENT</h5>
              You may not assign, transfer, or sublicense any of your rights or obligations under these Terms and Conditions without our prior written consent. We may assign, transfer, or sublicense our rights and obligations to third parties at any time.
              </li>
              <li><h5 className="mt-4">CONDUCT OF MEMBERS</h5>
              <ol>
                <li>Members must comply with all applicable laws and regulations when using the Site.
                </li>
                <li>Any fraudulent activity or violation of these Terms and Conditions by a Member may result in the termination of their account and legal action.
                </li>
              </ol>
              </li>
              <li><h5 className="mt-4">FEEDBACK AND COMPLAINTS</h5>
              We value your feedback and are committed to resolving any complaints. Please contact us at support@blaccdot.com for any concerns or issues regarding the Site.
              </li>
            </ol>
           
            </Box>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            I agree
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Tcmodel;